export default __webpack_public_path__ + "static/media/bronze.5fe00423.png";